import { atom } from 'jotai'

export const settingsTabStateAtom = atom({ open: false })
